import { Facet } from '../models/Facet';

/**
 * Facet for drive access token
 */
export const driveAccessTokenFacet: Facet<{
  accessToken: string;
  tokenUrl: string;
  timeReceived: Date;
  expirationTime: Date;
}> = new Facet('driveAccessToken');

/**
 * Facet for download as Zip Api Url
 */
export const downloadAsZipApiUrlFacet: Facet<string> = new Facet('downloadAsZipApiUrl');
